<template>
    <div class="field">
        <div
            v-if="!userData.name || !userData.name.length"
            class="notification is-danger is-small"
        >
            <p v-t="'userProfile.name_required'"></p>
        </div>

        <div class="field is-horizontal is-grouped">
            <div class="field-body">
                <div class="field">
                    <p
                        class="control is-expanded has-icons-left has-tooltip-top has-tooltip-danger"
                    >
                        <input
                            v-model="userData.name"
                            :placeholder="$t('name')"
                            class="input"
                            type="text"
                        />
                        <span class="icon is-small is-left">
                            <i class="fas fa-user" />
                        </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control is-expanded has-icons-left">
                        <input
                            v-model="userData.email"
                            class="input is-success is-static"
                            type="email"
                            readonly
                            placeholder="Email"
                        />
                        <span class="icon is-small is-left">
                            <i class="fas fa-envelope" />
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="field">
            <p class="control is-expanded">
                <textarea
                    v-model="userData.description"
                    :placeholder="$t('description')"
                    class="textarea"
                ></textarea>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style></style>
